var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "59B57957-D40A-4272-B247-8938EBB54CFE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loja",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loja---Comprar-Certificado-Resumo-da-Compra",
    transform: "translate(-174.000000, -182.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-check-circle",
    transform: "translate(174.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85,12.15 L6.75,14.25 L13.5,21 L28.5,6 L26.4,3.9 L13.5,16.8 L8.85,12.15 L8.85,12.15 Z M27,15 C27,21.6 21.6,27 15,27 C8.4,27 3,21.6 3,15 C3,8.4 8.4,3 15,3 C16.2,3 17.25,3.15 18.3,3.45 L20.7,1.05 C18.9,0.45 16.95,0 15,0 C6.75,0 0,6.75 0,15 C0,23.25 6.75,30 15,30 C23.25,30 30,23.25 30,15 L27,15 L27,15 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.a4307ce0ca9ad5b8131d5cb0dc56a371.svg";
export { ForwardRef as ReactComponent };